'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var BACKSPACE = exports.BACKSPACE = 8;
var BRACKET_LEFT = exports.BRACKET_LEFT = 219;
var BRACKET_RIGHT = exports.BRACKET_RIGHT = 221;
var DOWN = exports.DOWN = 40;
var ENTER = exports.ENTER = 13;
var TAB = exports.TAB = 9;
var ESC = exports.ESC = 27;
var LEFT = exports.LEFT = 37;
var NBSP = exports.NBSP = 160;
var RIGHT = exports.RIGHT = 39;
var SPACE = exports.SPACE = 32;
var UP = exports.UP = 38;
var Y = exports.Y = 89;
var Z = exports.Z = 90;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.348/js/constants/KeyCodes.js
// module id = 55
// module chunks = 0 1